<form [formGroup]="pharmacyDetailsForm" class="dialog-content primary">
  <div class="dialog-header">
    <div class="header">
      {{pharmacyId ? 'Edit' : 'Review'}} pharmacy details
    </div>

    <div *ngIf="!pharmacyId && location === PharmacyLocationEnum.Setup" class="description">
      Please confirm the following pharmacy information to continue setting up your account.
      <ng-container *ngIf="location !== PharmacyLocationEnum.Settings">
        You’ll be able to add more pharmacies later.
      </ng-container>
    </div>

    <div *ngIf="!pharmacyId && location === PharmacyLocationEnum.Settings" class="description">
      Please confirm the following pharmacy information to continue adding this location.
    </div>

    <div *ngIf="pharmacyId" class="description">
      Manage your pharmacy details.
    </div>
  </div>

  <div class="dialog-body">
    <div class="form-fields">
      <div class="label-optional-fields">
        Optional fields are noted below.
      </div>

      <div class="form-row two-items">
        <app-input class="custom-input"
                   [label]="'Pharmacy name'"
                   formControlName="pharmacyName"
                   [type]="'text'"
                   (keyupEnter)="focusInput('phoneNumberInput')"
                   #pharmacyDetailsInput
        ></app-input>
        <app-input class="custom-input"
                   [label]="'Phone number'"
                   formControlName="phoneNumber"
                   [type]="'phone'"
                   (keyupEnter)="focusInput('streetAddressInput')"
                   #phoneNumberInput
        ></app-input>
      </div>

      <div class="form-row two-items">
        <app-input class="custom-input"
                   [label]="'Street address'"
                   formControlName="streetAddress"
                   [type]="'text'"
                   (keyupEnter)="focusInput('addressExtensionInput')"
                   #streetAddressInput
        ></app-input>
        <app-input class="custom-input"
                   [label]="'Suite, studio, or floor'"
                   formControlName="addressExtension"
                   [type]="'text'"
                   [optional]="true"
                   (keyupEnter)="focusInput('cityInput')"
                   #addressExtensionInput
        ></app-input>
      </div>

      <div class="form-row three-items">
        <app-input class="custom-input"
                   [label]="'City'"
                   formControlName="city"
                   [type]="'text'"
                   (keyupEnter)="focusDropdown('stateDropdown')"
                   #cityInput
        ></app-input>
        <app-dropdown [isLoading]="loading$ | async"
                      [label]="'State'"
                      [placeholder]="'Chose State'"
                      formControlName="state"
                      [isOptionObject]="false"
                      [options]="states$ | async"
                      (chosenOption)="focusInput('zipInput')"
                      #stateDropdown
        ></app-dropdown>
        <app-input class="custom-input"
                   [label]="'Zip code'"
                   formControlName="zipCode"
                   [type]="'number'"
                   [maxLength]="5"
                   (keyupEnter)="focusInput('licenseNumberInput')"
                   [isZipCodeNumber]="true"
                   #zipInput
        ></app-input>
      </div>

      <div class="form-row two-items top-bordered">
        <app-input class="custom-input"
                   [label]="'License number'"
                   formControlName="licenseNumber"
                   (keyupEnter)="focusDatepicker('licenseDateExpDatepicker')"
                   #licenseNumberInput
        ></app-input>
        <app-datepicker-input [label]="'License expiration'"
                              formControlName="licenseExpiration"
                              [dateMin]="today"
                              (dateTimeChange)="focusInput('deaNumberInput')"
                              #licenseDateExpDatepicker
        ></app-datepicker-input>
      </div>

      <div class="form-row two-items">
        <app-input class="custom-input"
                   [label]="'DEA number'"
                   formControlName="deaNumber"
                   [type]="'text'"
                   (keyupEnter)="focusDatepicker('deaDateExpDatepicker')"
                   #deaNumberInput
        ></app-input>
        <app-datepicker-input [label]="'DEA expiration'"
                              formControlName="deaExpiration"
                              [dateMin]="today"
                              (inputTabKeyDown)="continue()"
                              #deaDateExpDatepicker
        ></app-datepicker-input>
      </div>
    </div>

    <div class="controls">
      <app-button *ngIf="!pharmacyId"
                  [minWidth]="0"
                  customClasses="px-4"
                  subStyle="transparent"
                  class="prev-btn"
                  (clicked)="closeForm()"
      >
        <img class="chevron-icon"
             src="../../../../../assets/icons/icon-dropdown-chevron-right-gray.svg"
             alt="icon-chevron-left"
        />
        Back
      </app-button>

      <app-button *ngIf="pharmacyId"
                  [minWidth]="0"
                  customClasses="px-4"
                  text="Cancel"
                  subStyle="transparent"
                  class="cancel"
                  (clicked)="closeForm()"
      >
      </app-button>

      <app-button [text]="location === PharmacyLocationEnum.Setup ? 'Next' : 'Finish'"
                  class="continue-btn"
                  [disabled]="pharmacyLoading$ | async"
                  (clicked)="continue()"
      >
      </app-button>
    </div>
  </div>

</form>
